import React from 'react';
import { Centered } from '../../atoms/layouts/Centered';
import { Loader } from './Loader';

type RoutePendingProps = {
  label?: string;
};

/**
 * What a route shows while its loader runs or its component suspends on `useSuspenseQuery`. The
 * router renders it as the route's Suspense fallback, so pages need no `<Suspense>` of their own.
 * The router-wide default is the generic label; a route that wants its own sets
 * `pendingComponent: () => <RoutePending label="Loading projects..." />`.
 */
export const RoutePending = ({ label = 'Loading...' }: RoutePendingProps) => (
  <Centered tryGoldenCenter>
    <Loader label={label} />
  </Centered>
);
